import { Button, Layout, Skeleton, Space, theme, Typography } from "antd";
import React, { useContext, useRef, useState } from "react";
import {
  initPrestationSlice,
  setPropertiesPrestation,
  updatePrestation,
} from "../Slices/Prestation.slice";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import routes from "../../../engine/routes";
import { EditFilled, PhoneOutlined, UserOutlined } from "@ant-design/icons";
import { HiOutlineMail } from "react-icons/hi";
import {
  renderUserName,
  renderUserNameEmail,
  roles,
  subRoles,
} from "../../../utils/constants";
import { PrestationHeader } from "../../../shared/components/PrestationHeader/PrestationHeader";
import { CreateApplicant } from "../../../shared/components/CreateApplicant/CreateApplicant";
import { modalsByContext } from "../../../shared/components/Modals/modals";
import { ModalContext } from "../../../engine/context/Modal.provider";
import { IoAddSharp } from "react-icons/io5";
import {
  renderAdress,
  typeAddress,
} from "../../../shared/container/Addresses/AddresseItem/AddresseHelpers";
import { LuMapPin } from "react-icons/lu";
import { usePrestationDisabler } from "../../../engine/hooks/usePrestationDisabler";
import {GrPowerReset} from "react-icons/gr";

const { Content, Sider, Header, Footer } = Layout;

export function PrestationInformations({ isNew }) {
  const { id } = useParams();
  const { prestation, loading } = useSelector(state => state.prestation);
  const { intervenant, responsable } = prestation;

  const [disabled] = usePrestationDisabler();


  const { init, clear } = initPrestationSlice({ id });
  const navigate = useNavigate();

  const [change, setChange] = useState(undefined);

  const context = useContext(ModalContext);

  const dispatch = useDispatch();

  const formRef = useRef(null);

  const {
    token: { colorBgLyout },
  } = theme.useToken();

  const inputs = [
    {
      parentLabel: "",
      children: [
        {
          label: "N° de commande",
          name: "reference",
          disabled: true,
          capitalize: false,
          required: true,
          type: "input",
          variant: "important",
          col: 24,
        },
      ],
    },
    {
      parentLabel: "Adresse de facturation",
      children: [
        {
          type: "input-hidden",
          name: "institutionBilling",
        },
        {
          label: "Adresse de facturation",
          name: "billing",
          quote: (
            <>
              <p>Vous pouvez les éditer sur la page de l'institution </p>
              <a
                target={"_blank"}
                href={
                  routes.institutions(prestation?.institution?._id).addresses
                    .path
                }
              >
                Editer les addresses
              </a>
            </>
          ),
          disabled: disabled,
          quoteIcon: "edit",
          addonBefore: <EditFilled />,
          type: "dynamic-select",
          required: true,
          value:
            prestation.billing === null
              ? prestation?.institution?.defaultAddress
              : prestation.billing._id,
          multiple: false,
          endPoint: `addresses?institution=${prestation?.institution?._id}&type=${typeAddress.postal}`,
          updateEndPoint: [change],
          itemsCallBack: addresses => {},
          inputSize: "large",
          noSorting: true,
          onChange: ({ value, ref, dynamicSource }) => {
            ref.current.setFieldsValue({
              institutionBilling: dynamicSource.institution._id,
            });
          },
          itemCallback: adress => {
            return {
              key: adress._id,
              label: renderAdress(
                adress,
                prestation?.institution?.defaultAddress === adress._id,
                prestation?.institution,
              ),
              value: adress._id,
            };
          },
          col: 24,
        },
        {
          type: "component",
          component: ({ disabled }) => {
            return (
              <>
                <Button
                  disabled={disabled}
                  onClick={() => {
                    context.openModal(
                      modalsByContext.InstitutionNewAddress,
                      {
                        institution: prestation.institution?._id,
                        principal: null,
                        type: typeAddress.postal,
                      },
                      () => setChange(Math.random()),
                    );
                  }}
                  size={"small"}
                  style={{
                    justifySelf: "flex-start",
                    display: "flex",
                  }}
                  icon={
                    <IoAddSharp
                      style={{
                        marginTop: "0px",
                      }}
                      size={25}
                    />
                  }
                >
                  Ajouter une adresse
                </Button>
              </>
            );
          },
          col: 24,
        },
      ],
    },
    {
      parentLabel: "Responsable de l'entretien",
      children: [
        // {
        //   label: "Intervenant (a supprimer, ancienne méthode, pour comparer)",
        //   name: "intervenant",
        //   value: intervenant?._id,
        //   type: "dynamic-select",
        //   endPoint: `/responsables?institution=${prestation.institution?._id}`,
        //   // watchRenderCondition: true,
        //   quote: (
        //     <>
        //       <p>Vous pouvez les éditer sur la page de l'institution </p>
        //       <a
        //         target={"_blank"}
        //         href={
        //           routes.institutions(prestation?.institution?._id).responsables
        //             .path
        //         }
        //       >
        //         Editer les responsables d'entretien
        //       </a>
        //     </>
        //   ),
        //   quoteIcon: "edit",
        //   addonBefore: <EditFilled />,
        //   updateEndPoint: [change],
        //   itemCallback: item => {
        //     return {
        //       key: item._id,
        //       label: renderUserNameEmail(item),
        //       value: item._id,
        //     };
        //   },
        //   col: 24,
        // },
        {
          type: "component",
          component: ({ disabled }) => {
            return (
              <>
                <Space direction={"horizontal"}>
                  <Button
                    disabled={disabled}
                    type={"primary"}
                    onClick={() => {
                      context.openModal(
                        modalsByContext.SelectResponsable,
                        {
                          institution: prestation.institution?._id,
                          formRef,
                        },
                        ({ _id, data }) => {
                          if (data) {
                            formRef.current.setFieldsValue({
                              "responsable.firstname": data.firstname,
                              "responsable.email": data.email,
                              "responsable.phone": data.phone,
                              "responsable.lastname": data.lastname,
                            });
                            setChange(_id);
                          }
                        },
                      );
                    }}
                    icon={
                      <UserOutlined
                        style={{
                          marginTop: "0px",
                        }}
                        size={15}
                      />
                    }
                    size={"small"}
                  >
                    Sélectionner un responsable d'entretien prédéfini
                  </Button>
                  <CreateApplicant
                    disabled={disabled}
                    institution={prestation.institution?._id}
                    key={Math.random()}
                    name={"intervenant"}
                    formRef={formRef}
                    onCreated={(_id, data) => {
                      formRef.current.setFieldsValue({
                        "responsable.firstname": data.firstname,
                        "responsable.email": data.email,
                        "responsable.phone": data.phone,
                        "responsable.lastname": data.lastname,
                      });
                      setChange(_id);
                    }}
                  />
                  <Button
                    disabled={disabled}
                    type={"text"}
                    onClick={() => {
                      formRef.current.setFieldsValue({
                        "responsable.firstname": '',
                        "responsable.email": '',
                        "responsable.phone": '',
                        "responsable.lastname": '',
                      });
                      setChange(null);
                    }}

                    size={"small"}
                    icon={<GrPowerReset style={{ marginTop: "-3px" }} size={15} />}

                  >
                    Réinitialiser
                  </Button>
                </Space>
              </>
            );
          },
          col: 24,
        },

        {
          placeholder: "Nom",
          name: "responsable.lastname",
          type: "input",
          addonBefore: <UserOutlined />,
          col: 12,
          disabled: true,
        },
        {
          placeholder: "Prénom",
          name: "responsable.firstname",
          addonBefore: <UserOutlined />,
          type: "input",
          col: 12,
          disabled: true,
        },
        {
          placeholder: "Email",
          name: "responsable.email",
          addonBefore: <HiOutlineMail />,
          type: "input",
          col: 12,
          disabled: true,
        },
        {
          placeholder: "Téléphone",
          name: "responsable.phone",
          addonBefore: <PhoneOutlined />,
          type: "input",
          col: 12,
          disabled: true,
        },
      ],
    },
    {
      parentLabel: "Commentaires ",
      children: [
        {
          label:
            "Commentaire interne (uniquement visible par les membres de l’institution)",
          name: "comment.internal",
          type: "textarea",
          col: 24,
        },
        {
          label: "Commentaire pour l’interprète",
          name: "comment.interprete",
          type: "textarea",
          col: 24,
        },
      ],
    },
    {
      parentLabel: "Bénéficiaire",
      description:
        "Les informations affichées ci-dessous apparaîtront dans la facture.",
      children: [
        {
          label: "Référence du bénéficiaire",
          name: "beneficiary.reference",
          type: "input",
          col: 24,
        },
        {
          label: "Nom du bénéficiaire",
          name: "beneficiary.firstname",
          type: "input",
          col: 24,
        },
        {
          label: "Prénom du bénéficiaire",
          name: "beneficiary.lastname",
          type: "input",
          col: 24,
        },
      ],
    },

    {
      children: [
        {
          label: "Sauvegarder & suivant",
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "right",
        },
      ],
    },
  ];
  const formatString = s => {
    return Number(s.replace(/[^0-9.-]+/g, ""));
  };
  const onSubmitForm = async data => {
    data.steps ??= {};

    data.steps.resume = true;

    await dispatch(setPropertiesPrestation(data));
    await dispatch(updatePrestation("resume"));
    await navigate(routes.prestations(id).detailResume.path);
  };
  return (
    <>
      <PrestationHeader
        title={routes.prestations(id).detailInformations.title}
      />
      {loading ? (
        <Skeleton active />
      ) : (
        <>
          <CustomForm
            disabled={disabled}
            initialValues={prestation}
            dataSource={inputs}
            handleSubmit={data => onSubmitForm(data)}
            labelCol={24}
            refForm={formRef}
            wrapperCol={24}
            onValuesChange={undefined}
          />
        </>
      )}
    </>
  );
}
